<div class="columns is-multiline is-desktop">
  <div class="column">
    <div class="box">
      <iss-form-field>
        <iss-label>{{ 'button.impersonation' | translate }}</iss-label>
        <input
          issInput
          placeholder="{{ 'User to impersonate' }}"
          [formControl]="impersonateId"
          data-e2e="impersonate id field"
        />
        <ng-template issFormFieldError let-errors>
          <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
        </ng-template>
      </iss-form-field>
    </div>
    <div class="field is-grouped is-grouped-right">
      <div class="control">
        <button
          tuiButton appearance="outline"
          data-e2e="cancel impersonation button"
          (click)="closeDialog()"
        >{{ 'button.cancel' | translate }}</button>
      </div>
      <div class="control">
        <button
          tuiButton
          data-e2e="confirm impersonation button"
          (click)="setImpersonateId()"
        >{{ 'button.impersonate' | translate }}</button>
      </div>
    </div>
  </div>
</div>
